export const facialServices = [
  {
    id: "limpeza-pele",
    title: "Limpeza de Pele Profunda",
    description:
      "Protocolo completo de higienização facial com extração profissional, vapor de ozônio, ledterapia e máscara personalizada de acordo com cada tipo de pele. Indicado para todos os tipos de pele, remove impurezas, reduz poros dilatados e devolve o viço natural.",
    imageSeq: "facial-01",
    imageQuery:
      "Professional facial cleansing treatment on a woman with soft natural lighting, clean white aesthetic background, spa atmosphere, editorial beauty photography with warm neutral tones and soft shadows, elegant minimalist composition",
  },
  {
    id: "tratamento-manchas",
    title: "Tratamento para Manchas e Acne",
    description:
      "Protocolo não invasivo que combina ativos clareadores de última geração e peelings enzimáticos para tratar hiperpigmentação, marcas de acne e uniformizar o tom da pele. Tecnologia LED auxilia na regeneração celular sem agredir a pele.",
    imageSeq: "facial-02",
    imageQuery:
      "Close-up of a woman receiving gentle non-invasive skin treatment for spots and blemishes, spa environment with soft diffused light, white and beige tones, elegant aesthetic, clean minimalist beauty photography with warm ambiance and delicate hands applying treatment",
  },
  {
    id: "consultoria-home-care",
    title: "Consultoria de Rotina Home Care",
    description:
      "Anamnese detalhada e personalizada com análise completa da pele, identificação de necessidades específicas e prescrição de rotina de cuidados diários. Inclui guia de produtos, ordem de aplicação e acompanhamento para garantir resultados consistentes.",
    imageSeq: "facial-03",
    imageQuery:
      "Elegant skincare consultation scene with a beauty professional analyzing a client skin, notebook with skincare routine plan, luxury cosmetic products neatly arranged on white marble surface, soft natural window lighting, warm neutral color palette, sophisticated editorial style",
  },
];

export const eyebrowServices = [
  {
    id: "design-tradicional",
    title: "Design de Sobrancelhas Tradicional",
    description:
      "Modelagem personalizada respeitando o formato natural do rosto, ângulo e proporção áurea. Técnica precisa com pinça e cera de baixa temperatura para um acabamento impecável e duradouro.",
    icon: "ri-brush-3-line",
  },
  {
    id: "design-henna",
    title: "Design com Henna",
    description:
      "Design completo com aplicação de henna natural para preencher falhas, dar definição e cor às sobrancelhas. Efeito natural que dura de 5 a 10 dias, ideal para quem deseja sobrancelhas mais cheias sem maquiagem diária.",
    icon: "ri-paint-line",
  },
  {
    id: "tintura-sobrancelhas",
    title: "Tintura de Sobrancelhas",
    description:
      "Coloração profissional dos fios para um olhar mais marcante e definido. A tintura escurece os pelinhos mais finos e claros, criando um efeito de sobrancelhas mais cheias e expressivas. Resultado imediato com duração de 2 a 3 semanas.",
    icon: "ri-palette-line",
  },
  {
    id: "brow-lamination",
    title: "Brow Lamination",
    description:
      "Técnica avançada que alinha e modela os fios no sentido desejado, criando sobrancelhas mais volumosas, alinhadas e com efeito penteado natural. Resultado imediato com duração de 4 a 6 semanas. O efeito lifting que revolucionou o design de sobrancelhas.",
    icon: "ri-eye-line",
  },
];

export const differentials = [
  {
    id: "dif-1",
    title: "Atendimento Personalizado",
    description:
      "Cada cliente recebe um protocolo exclusivo desenvolvido após anamnese completa. Nenhum tratamento é igual — porque nenhuma pele é igual.",
    icon: "ri-star-line",
  },
  {
    id: "dif-2",
    title: "Técnicas Exclusivas",
    description:
      "Jennifer Siqueira domina técnicas avançadas desenvolvidas com os melhores profissionais do Brasil, combinando ciência e arte em cada procedimento.",
    icon: "ri-award-line",
  },
  {
    id: "dif-3",
    title: "Resultados Duradouros",
    description:
      "Produtos de alta performance, tecnologia de ponta e acompanhamento contínuo garantem resultados que vão além da sessão — transformam a relação com sua pele.",
    icon: "ri-shining-line",
  },
  {
    id: "dif-4",
    title: "Ambiente Exclusivo",
    description:
      "Nosso studio foi projetado para ser um refúgio de tranquilidade e bem-estar. Cada detalhe — da iluminação à música ambiente — é pensado para sua experiência.",
    icon: "ri-home-heart-line",
  },
];

export const testimonials = [
  {
    id: "dep-1",
    text: "Tá top a pele! Lisinha, sabe? E sensação de limpeza mesmo, amei! Vi muita diferença até na hora de passar a maquiagem.",
    role: "Limpeza de Pele",
  },
  {
    id: "dep-2",
    text: "Estou muito satisfeita com o resultado. Só de olhar no espelho e não ver aqueles pontinhos pretinhos já é um alívio enorme.",
    role: "Limpeza de Pele",
  },
  {
    id: "dep-3",
    text: "Ficou simplesmente impecável o trabalho! Ficou foda o resultado, Jennifer. Curti pra caralho! Obrigada por cuidar tão bem de mim.",
    role: "Design de Sobrancelhas",
  },
];